import BigNumber from 'bignumber.js'

const DataValidator = class {
    validate(data, validateRules, multi) {
        if ((typeof multi) != 'boolean') {
            multi = true
        }

        if ((typeof validateRules) != 'object' || validateRules.constructor != Array || validateRules.length < 1) {
            return multi ? {} : ''
        }

        const dataKeys = Object.keys(data)
        const validationErrors = {}

        for (let rule of validateRules) {
            const parts = rule.split('@')
            const fieldName = parts.shift()
            let checkOnNotEmpty = false
            let validator = 'StrNotEmpty'
            let errorTips = '必须填写'

            for (let part of parts) {
                if (part == 'WithNotEmpty') {
                    checkOnNotEmpty = true
                    continue
                }

                if (part.startsWith('msg:')) {
                    errorTips = part.replace(/^msg:/, '')
                    continue
                }

                validator = part
            }

            switch (validator) {
                case 'MobileNumber':
                    errorTips = '不是有效的手机号码'
                    break
                case 'Email':
                    errorTips = '不是有效的邮箱地址'
                    break
                case 'PasswordTooSimple':
                    errorTips = '密码过于简单'
                    break
                case 'IdcardNo':
                    errorTips = '不是有效的身份证号码'
                    break
            }

            if (multi && validationErrors[fieldName]) {
                continue
            }

            const fieldValue = dataKeys.includes(fieldName) ? `${data[fieldName]}` : ''

            if (checkOnNotEmpty && fieldValue == '') {
                continue
            }

            if (fieldValue == '') {
                if (!multi) {
                    return errorTips
                }

                validationErrors[fieldName] = errorTips
                continue
            }

            if (validator == 'StrNotEmpty') {
                continue
            }

            if (validator.startsWith('EqualWith:')) {
                const equalWithFieldName = validator.replace('EqualWith:', '')

                if (!dataKeys.includes(equalWithFieldName)) {
                    continue
                }

                if (fieldValue != `${data[equalWithFieldName]}`) {
                    if (!multi) {
                        return errorTips
                    }

                    validationErrors[fieldName] = errorTips
                }

                continue
            }

            let args = validator.split(':')
            const fn = 'is' + args.shift()
            args = [fieldValue, ...args]

            if ((typeof this[fn]) != 'function') {
                continue
            }

            if (this[fn].apply(this, args)) {
                continue
            }

            if (!multi) {
                return errorTips
            }

            validationErrors[fieldName] = errorTips
        }

        return multi ? validationErrors : ''
    }

    isInt(value) {
        return value == '0' || /^\-?[1-9][0-9]*$/.test(value)
    }

    isIntEq(value, num) {
        return this.isInt(value) && parseInt(value) == parseInt(num)
    }

    isIntNe(value, num) {
        return this.isInt(value) && parseInt(value) != parseInt(num)
    }

    isIntGt(value, num) {
        return this.isInt(value) && parseInt(value) > parseInt(num)
    }

    isIntGe(value, num) {
        return this.isInt(value) && parseInt(value) >= parseInt(num)
    }

    isIntLt(value, num) {
        return this.isInt(value) && parseInt(value) < parseInt(num)
    }

    isIntLe(value, num) {
        return this.isInt(value) && parseInt(value) <= parseInt(num)
    }

    isIntGtLt(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })

        return this.isInt(value) && parseInt(value) > range[0] && parseInt(value) < range[1]
    }

    isIntGeLe(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })
        return this.isInt(value) && parseInt(value) >= range[0] && parseInt(value) <= range[1]
    }

    isIntGtLe(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })

        return this.isInt(value) && parseInt(value) > range[0] && parseInt(value) <= range[1]
    }

    isIntGeLt(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })

        return this.isInt(value) && parseInt(value) >= range[0] && parseInt(value) < range[1]
    }

    isIntIn(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })

        return this.isInt(value) && range.includes(range)
    }

    isIntNotIn(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })

        return this.isInt(value) && !range.includes(range)
    }

    isFloat(value) {
        if (this.isInt(value)) {
            return true
        }

        return /^\-?[0-9]+\.[0-9]+$/.test(value)
    }

    isFloatEq(value, num) {
        return this.isFloat(value) && new BigNumber(value).isEqualTo(num)
    }

    isFloatNe(value, num) {
        return this.isFloat(value) && !(new BigNumber(value).isEqualTo(num))
    }

    isFloatGt(value, num) {
        return this.isFloat(value) && new BigNumber(value).isGreaterThan(num)
    }

    isFloatGe(value, num) {
        return this.isFloat(value) && new BigNumber(value).isGreaterThanOrEqualTo(num)
    }

    isFloatLt(value, num) {
        return this.isFloat(value) && new BigNumber(value).isLessThan(num)
    }

    isFloatLe(value, num) {
        return this.isFloat(value) && new BigNumber(value).isLessThanOrEqualTo(num)
    }

    isFloatGtLt(value, range) {
        if (!this.isFloat(value)) {
            return false
        }

        value = new BigNumber(value)

        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return new BigNumber(it)
        })

        return this.isFloat(value) && value.isGreaterThan(range[0]) && value.isLessThan(range[1])
    }

    isFloatGeLe(value, range) {
        if (!this.isFloat(value)) {
            return false
        }

        value = new BigNumber(value)

        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return new BigNumber(it)
        })

        return this.isFloat(value) && value.isGreaterThanOrEqualTo(range[0]) && value.isLessThanOrEqualTo(range[1])
    }

    isFloatGtLe(value, range) {
        if (!this.isFloat(value)) {
            return false
        }

        value = new BigNumber(value)

        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return new BigNumber(it)
        })

        return this.isFloat(value) && value.isGreaterThan(range[0]) && value.isLessThanOrEqualTo(range[1])
    }

    isFloatGeLt(value, range) {
        if (!this.isFloat(value)) {
            return false
        }

        value = new BigNumber(value)

        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return new BigNumber(it)
        })

        return this.isFloat(value) && value.isGreaterThanOrEqualTo(range[0]) && value.isLessThan(range[1])
    }

    isStrEq(value, str, ignoreCase) {
        if (ignoreCase) {
            value = value.toLowerCase()
            str = str.toLowerCase()
        }

        return value == str
    }

    isStrEqI(value, str) {
        return this.isStrEq(value, str, true)
    }

    isStrNe(value, str) {
        return !this.isStrEq(value, str)
    }

    isStrNeI(value, str) {
        return !this.isStrEqI(value, str)
    }

    isStrIn(value, range, ignoreCase) {
        range = range.split(/[\x20\t]*,[\x20\t]*/)

        if (ignoreCase) {
            value = value.toLowerCase()

            range = range.map(it => {
                return it.toLowerCase()
            })
        }

        return range.includes(value)
    }

    isStrInI(value, range) {
        return this.isStrIn(value, range, true)
    }

    isStrNotIn(value, range) {
        return !this.isStrIn(value, range)
    }

    isStrNotInI(value, range) {
        return !this.isStrInI(value, range)
    }

    isStrLen(value, num) {
        return value.length == parseInt(num)
    }

    isStrLenGe(value, num) {
        return value.length >= parseInt(num)
    }

    isStrLenLe(value, num) {
        return value.length <= parseInt(num)
    }

    isStrLenGeLe(value, range) {
        range = range.split(/[\x20\t]*,[\x20\t]*/).map(it => {
            return parseInt(it)
        })

        return value.length >= range[0] && value.length <= range[1]
    }

    isLetters(value) {
        return /^[A-Za-z]+$/.test(value)
    }

    isAlphabet(value) {
        return this.isLetters(value)
    }

    isNumbers(value) {
        return /^[0-9]+$/.test(value)
    }

    isDigits(value) {
        return this.isNumbers(value)
    }

    isLettersNumbers(value) {
        return /^[A-Za-z0-9]+$/.test(value)
    }

    isMobileNumber(value) {
        if (!/^[1-9][0-9]+$/.test(value)) {
            return false
        }

        return value.length >= 11
    }

    isEmail(value) {
        const regex = /^[\w\.~!#\$\%\^&\*\(\)\-\+\=\[\]\{\},\<\>]+@.+\.[A-Za-z]{2,}$/
        return regex.test(value)
    }

    isPasswordTooSimple(value) {
        const daxie = []

        for (let i = 65; i <= 90; i++) {
            daxie.push(String.fromCharCode(i))
        }

        const xiaoxie = []

        for (let i = 97; i <= 122; i++) {
            xiaoxie.push(String.fromCharCode(i))
        }

        const digits = Array(10).fill(0).map((it, i) => {
            return `${i}`
        })

        let n1 = 0
        let n2 = 0
        let n3 = 0
        let n4 = 0

        for (let ch of [...value]) {
            if (daxie.includes(ch)) {
                n1 = 1
                continue
            }

            if (xiaoxie.includes(ch)) {
                n2 = 1
                continue
            }

            if (digits.includes(ch)) {
                n3 = 1
                continue
            }

            n4 = 1
        }

        return (n1 + n2 + n3 + n4) >= 3
    }

    isIdcardNo(value) {
        if (!/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
            return false
        }

        const chars = [...value]
        const s1 = chars[17].toLowerCase()
        const a1 = ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2']
        const a2 = ['1', '0', 'x', '9', '8', '7', '6', '5', '4', '3', '2']
        let sum = 0

        for (let i = 0; i < chars.length - 1; i++) {
            sum += parseInt(chars[i]) * parseInt(a1[i])
        }

        return a2[sum % 11] == s1
    }

    isRegexp(value, regexp) {
        return new RegExp(regexp).test(value)
    }
}

export default DataValidator



// WEBPACK FOOTER //
// ./src/libs/data_validator.js